/* eslint-disable complexity */
import './style.css';

import React from 'react';
import { Typography } from '@vtblife/uikit';

import classname from '@search/classname/src';
import Icon from '@vtblife/uikit-icons';
import { getGtmLabel } from '../../../../domain/GtmContext';
import {
    MinimalBanksMortgageOffersQueryResponseOffer,
    MinimalBanksMortgageOffer as MinimalBanksMortgageOfferType
} from '../MinimalBanksMortgage/MinimalBanksMortgageOffers/MinimalBanksMortgageOffers';
import { MortgageOfferIcon } from './MortgageOfferIcon';

const cn = classname.bind(null, 'BanksMortgageOffers');

interface MinimalBanksMortgageOfferProps {
    offer: {
        description?: string;
        disabled?: boolean;
        minimalPercentDiscountFormatted?: string;
        minimalPaymentDiscountFormatted?: string;
    } & MinimalBanksMortgageOffersQueryResponseOffer;
    gtmCommonClick?: string;
    selectMortgageOffer?(offer: MinimalBanksMortgageOfferType, e: React.MouseEvent<HTMLButtonElement>): void;
    isAlternativeBg?: boolean;
}

export const BankMortgageOffers = ({
    offer,
    gtmCommonClick,
    isAlternativeBg,
    selectMortgageOffer
}: MinimalBanksMortgageOfferProps) => {
    const equalPercent = offer?.minimalPercentDiscountFormatted === offer?.minimalPercentFormatted;
    const disabled = offer?.disabled;

    let name = offer?.name ?? '';

    if (offer?.type === 'FAMILY') name = 'Семейная ипотека';
    if (offer?.type === 'PREFERENTIAL') name = 'Льготная ипотека';
    if (offer?.type === 'IT_MORTGAGE') name = 'IT-ипотека';

    const description = offer?.disabled ? offer.description : undefined;

    return (
        <button
            onClick={disabled || ! selectMortgageOffer ? undefined : selectMortgageOffer.bind(null, offer)}
            type={disabled ? 'button' : 'submit'}
            className={cn('button', { disabled })}
            data-test={`MinimalBanksMortgageOffer-${offer?.bankId ?? 'unk'}`}
            {...getGtmLabel(gtmCommonClick)}
        >
            <div className={cn('', { isAlternativeBg })}>
                <div className={cn('offer')}>
                    <MortgageOfferIcon offer={offer} />
                    <Typography color='primary' tag='span' variant='secondary-alone'>
                        {name}
                    </Typography>
                </div>
                {description && (<Typography color='secondary'>{description}</Typography>)}
                {description ? null : (<div className={cn('offer-info')}>
                    <div className={cn('offer-percent')}>
                        <Typography
                            tag='span'
                            color='primary'
                            variant='promo-subheader'
                            bold
                            className={cn('percent', {
                                typed: Boolean(offer?.type),
                                discount: Boolean(offer?.minimalPercentDiscountFormatted) && ! equalPercent
                            })}
                        >
                            {offer?.type && (<div className={cn('icon')}><Icon size='s' name='lightning-circle' /></div>)}
                            {offer?.minimalPercentFormatted}
                        </Typography>
                        {! equalPercent && offer?.minimalPercentDiscountFormatted && <Typography variant='h3' color='orange-600'>
                            {offer.minimalPercentDiscountFormatted}
                        </Typography>}
                    </div>
                    <Typography color='primary' tag='span' className={cn('payment')}>
                        {offer?.minimalPaymentDiscountFormatted ?? offer?.minimalPaymentFormatted}
                    </Typography>
                </div>)}
            </div>
        </button>
    );
};
